function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import getEachDeep from './getEachDeep.js';
import getPathToString from './getPathToString.js';
export default function getMapKeysDeep(_) {
  var eachDeep = getEachDeep(_);
  var pathToString = getPathToString(_);
  function mapKeysDeep(obj, iteratee) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    iteratee = _.iteratee(iteratee);
    options.cloneDeep = options.cloneDeep || _.cloneDeep;
    options.callbackAfterIterate = false;
    var newPaths = [];
    eachDeep(obj, function (value, key, parent, context) {
      if (key === undefined) {
        return;
      }
      var newKey = iteratee(value, key, parent, context) + '';
      if (newKey === key) {
        return;
      }
      var oldPath = context.path;
      var oldPathStr = options.pathFormat === 'array' ? JSON.stringify(oldPath) : oldPath;
      var newPath = options.pathFormat === 'array' ? [].concat(_toConsumableArray(context.parent.path || []), _toConsumableArray(context.childrenPath || []), [newKey]) : pathToString([newKey], context.parent.path, context.childrenPath);
      var newPathStr = options.pathFormat === 'array' ? JSON.stringify(newPath) : newPath;
      if (!newPaths[context.depth - 1]) {
        newPaths[context.depth - 1] = [];
      }
      newPaths[context.depth - 1].push({
        oldPath: oldPath,
        oldPathStr: oldPathStr,
        newPath: newPath,
        newPathStr: newPathStr
      });
    }, options);
    var res = options.cloneDeep(obj);
    var d = newPaths.length;
    var _loop = function _loop() {
      if (!newPaths[d]) {
        return "continue";
      }
      var overwritten = {};
      newPaths[d].forEach(function (_ref) {
        var oldPath = _ref.oldPath,
          oldPathStr = _ref.oldPathStr,
          newPath = _ref.newPath,
          newPathStr = _ref.newPathStr;
        var value;
        if (Object.prototype.hasOwnProperty.call(overwritten, oldPathStr)) {
          value = overwritten[oldPathStr];
          delete overwritten[oldPathStr];
        } else {
          value = _.get(res, oldPath);
          if (value === undefined && !_.has(res, oldPath)) {
            return;
          }
          _.unset(res, oldPath);
        }
        if (_.has(res, newPath) && !Object.prototype.hasOwnProperty.call(overwritten, newPathStr)) {
          overwritten[newPathStr] = _.get(res, newPath);
        }
        _.set(res, newPath, value);
      });
    };
    while (d--) {
      var _ret = _loop();
      if (_ret === "continue") continue;
    }
    return res;
  }
  return mapKeysDeep;
}